(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewSetReport.controller:CrewSetReportCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('crewSetReport').controller('CrewSetReportCtrl',
			CrewSetReportCtrl);

	function CrewSetReportCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'CrewSetReportCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				origin : null,
				destination : null
			},
			masterList : {
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchCrewSetReport(params);
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
		}
		;

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search crew set report
		function searchCrewSetReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						"crew_set_report.rptdesign",
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["DepatureDate"] = param.fromDate;
			searchParamMap["ArrivalDate"] = param.toDate;
			searchParamMap["FromAirport"] = '';
			if (!!param.origin && !!param.origin.airPortCode) {
				searchParamMap["FromAirport"] = param.origin.airPortCode;
			}
			searchParamMap["ToAirport"] = '';
			if (!!param.destination && !!param.destination.airPortCode) {
				searchParamMap["ToAirport"] = param.destination.airPortCode;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			if (!!vm.model.searchCriteria.fromDate
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !!vm.model.searchCriteria.toDate
					&& !vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateAfterToDate) {
				return true;
			}
			return false;
		}
		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});

		})();
	}
}());